import { atom } from 'recoil'
import { FilterStateTypes } from './types'

export const filters = atom<FilterStateTypes>({
  key: 'filters',
  default: {}
})
